import { render, staticRenderFns } from "./SwitcherApp.vue?vue&type=template&id=2ffd0ad2&scoped=true&"
import script from "./SwitcherApp.vue?vue&type=script&lang=js&"
export * from "./SwitcherApp.vue?vue&type=script&lang=js&"
import style0 from "./SwitcherApp.vue?vue&type=style&index=0&id=2ffd0ad2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ffd0ad2",
  null
  
)

export default component.exports